<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Minha conta</span>
      </h1>
      <PrimaryButton class="px-5" @click="submit()" icon="fa-solid fa-floppy-disk">Salvar</PrimaryButton>
    </div>
  </div>

  <div class="align p-4 space_title">

    <div v-if="!loading || account.name" class="card">
      <div class="p-4">
        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <InputText label="Nome" v-model="account.name" :error="formErrors.name" disabled />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <InputText label="E-mail" v-model="account.email" :error="formErrors.email" disabled />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <InputText label="Senha" type="password" v-model="account.password" :error="formErrors.password" />
          </div>

          <template v-if="user.profile_type !== 'publipost'">
          <div class="col-12 col-md-6 mb-3">
            <InputText label="Data de nascimento" v-model="account.date_birth" :error="formErrors.date_birth" mask="##/##/####" disabled />
          </div>

          <div v-if="account.cpf_cnpj.length == 14" class="col-12 col-md-6 mb-3">
            <InputText label="CPF" v-model="account.cpf_cnpj" :error="formErrors.cpf_cnpj" mask="###.###.###-##" disabled />
          </div>

          <div v-else class="col-12 col-md-6 mb-3">
            <InputText label="CNPJ" v-model="account.cpf_cnpj" :error="formErrors.cpf_cnpj" mask="##.###.###/####-##" disabled />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <InputText label="Telefone" v-model="account.phone" :error="formErrors.phone" mask="(##) #####-####" disabled />
          </div>

          <div class="col-6 col-md-3 mb-3">
            <InputText label="Agência" v-model="account.agency" :error="formErrors.agency" disabled />
          </div>

          <div class="col-6 col-md-3 mb-3">
            <InputText label="Dígito" v-model="account.agency_digit" :error="formErrors.agency_digit" disabled />
          </div>

          <div class="col-6 col-md-3 mb-3">
            <InputText label="Conta" v-model="account.account" :error="formErrors.account" disabled />
          </div>

          <div class="col-6 col-md-3 mb-3">
            <InputText label="Dígito" v-model="account.account_digit" :error="formErrors.account_digit" disabled />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <SelectBox
                id="site"
                label="Banco"
                :items="banks"
                v-model="account.bank"
                disabled
              />
          </div>

          <div class="col-12 col-md-6 mb-3">
            <SelectBox
                id="account_type"
                label="Tipo de conta"
                :items="accountTypes"
                v-model="account.account_type"
                disabled
              />
          </div>
          </template>
        </div>
      </div>
    </div>

    <h6 v-if="!loading || account.name" class="mt-4">Preferências</h6>

    <div v-if="!loading || account.name" class="card mt-3">
      <div class="p-4 divisor">
        <div class="col-12 mt-2">
            <InputSwitch id="dark" label="Modo Dark" v-model:checked="account.dark" />
        </div>
      </div>
      <div class="p-4">
        <div class="col-12 mt-2">
            <InputSwitch id="menu_opened" label="Menu sempre aberto" v-model:checked="account.menu_opened" />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import InputText from '@/components/InputText.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import { inject, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useAccountStore } from '@/stores/AccountStore'
import SelectBox from '@/components/SelectBox.vue';
import PrimaryButton from '@/components/PrimaryButton.vue';
import { useToast, TYPE } from "vue-toastification";
import InputSwitch from '@/components/InputSwitch.vue';
import { useAuthStore } from '@/stores/AuthStore';
import {errorFormat} from "@/utils/errorFormat";

const toast = useToast();

const loader = inject('$loader');

const formErrors = ref({});

const accountStore = useAccountStore();
const { account, banks } = storeToRefs(accountStore);

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const loading = ref(true);

const accountTypes = ref([
  { id: 'cc', 'name': 'Conta corrente'},
  { id: 'cp', 'name': 'Conta poupança'},
]);

onMounted(async () => {
  loader.show();
  await accountStore.getAccount();
  loader.hide();
  loading.value = false;
});

const submit = async() => {
    let params = ref({
      password: account.value.password,
      dark: account.value.dark,
      menu_opened: account.value.menu_opened,
    });

    loader.show();
    formErrors.value = {};

      const formResult = await accountStore.updateAccount(params.value);
      if(formResult.success){
        toast('Conta atualizada', { type: TYPE.SUCCESS, timeout: 6000 });
        authStore.user.dark = account.value.dark;
        authStore.user.menu_opened = account.value.menu_opened;
      }
      else {
        formErrors.value = errorFormat(formResult.errors);
      }

    loader.hide();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}
</style>